<div class="nav-item nav-search">
  <!-- Search -->
  <div class="search-input open">
    <!-- Search Input -->
    <div class="header-search" *ngIf="!showMobileSearch" >
      <div class="search-input-icon"><span [data-feather]="'search'"></span></div>
      <input
        class="form-control input"
        type="text"
        placeholder="{{('HEADER.SEARCH_' + companyPlan) | translate}}"
        tabindex="0"
        data-search="search"
        autocomplete="off"
        name="main-page-search"
        (keyup)="searchUpdate($event)"
        (click)="toggleMobileSearch(true)"
        [(ngModel)]="searchText"
        #openSearch
      />
      <button *ngIf="this.searchText !== '' " class="btn search-input-close p-0" (click)="clearSearch()" aria-label="Close"><span [data-feather]="'x'"></span></button>
    </div>

    <!-- Search List -->
    <div class="search-list search-list-main" *ngIf="!isMobile" [class.show]="searchText.length > 1" #pageList>
      <!-- Pages -->
      <ng-container *ngIf="pages.length > 0; else noResultsPages">
        <div
          class="auto-suggestion"
          *ngFor="let page of pages; let i = index"
          [class.active]="i === activeIndex"
          (click)="navigatePage(page.link)"
          (keydown.enter)="navigatePage(page.link)"
          tabindex="0"
        >
          <div class="search-find d-flex justify-content-start align-items-center">
            <div class="result-icon">
              <span [data-feather]="page.icon"></span>
            </div>
            <div class="result-content">
              <span class="benefit-name">{{ page.name }}</span>
              <span class="breadcrumb-search-result">{{ page.subline | translate }}</span>
            </div>
            <div class="result-arrow">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_764_2539" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="8" y="5" width="8" height="14">
                  <path d="M15.7 12.7L9.7 18.7C9.5 18.9 9.3 19 9 19C8.7 19 8.5 18.9 8.3 18.7C7.9 18.3 7.9 17.7 8.3 17.3L13.6 12L8.3 6.7C7.9 6.3 7.9 5.7 8.3 5.3C8.7 4.9 9.3 4.9 9.7 5.3L15.7 11.3C16.1 11.7 16.1 12.3 15.7 12.7Z" fill="white"/>
                </mask>
                <g mask="url(#mask0_764_2539)">
                  <rect width="24" height="24" fill="#6E6B7B"/>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- No results found -->
      <ng-template #noResultsPages>
        <ul class="pl-0">
          <li class="auto-suggestion justify-content-between">
            <a class="d-flex align-items-center justify-content-between w-100 py-50">
              <div class="d-flex justify-content-start">
                <i data-feather="alert-circle" class="mr-25"></i>
                <span>{{'HEADER.NOT_FOUND' | translate}}</span>
              </div>
            </a>
          </li>
        </ul>
      </ng-template>
      <!--/ Pages -->
    </div>


    <!--/ Search List -->

    <!-- Search List -->
    <div class="search-list search-list-main mobile" *ngIf="isMobile"  [class.show]="showMobileSearch" #pageList>
      <div class="d-flex title-container mb">
        <div>{{('HEADER.SEARCH_' + companyPlan) | translate}}</div>
        <button class="btn search-input-close p-0" (click)="toggleMobileSearch(false)">{{'HEADER.CLOSE' | translate}}</button>
      </div>
      <div class="mobile-search-container mb">
        <div class="search-input-icon"><span [data-feather]="'search'"></span></div>
        <input
          class="form-control input"
          type="text"
          tabindex="0"
          data-search="search"
          autocomplete="off"
          name="mobile-page-search"
          (keyup)="searchUpdate($event)"
          (click)="toggleMobileSearch(true)"
          [(ngModel)]="searchText"
          #mobileInput
        />
        <button *ngIf="this.searchText !== '' " class="btn search-input-close p-0" (click)="clearSearch()"><span [data-feather]="'x'"></span></button>
      </div>
      <!-- Pages -->
      <ng-container *ngIf="pages.length > 0; else noResultsPages">
        <div
          class="auto-suggestion"
          *ngFor="let page of pages"
          (click)="navigatePage(page.link)"
          (keydown.enter)="navigatePage(page.link)"
        >
            <div class="search-find d-flex justify-content-start align-items-center">
              <div class="result-icon">
                <span [data-feather]="page.icon"></span>
              </div>
              <div class="result-content">
                <span class="benefit-name">{{ page.name }}</span>
                <span class="breadcrumb-search-result">{{ page.subline | translate }}</span>
              </div>
              <div class="result-arrow">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_764_2539" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="8" y="5" width="8" height="14">
                    <path d="M15.7 12.7L9.7 18.7C9.5 18.9 9.3 19 9 19C8.7 19 8.5 18.9 8.3 18.7C7.9 18.3 7.9 17.7 8.3 17.3L13.6 12L8.3 6.7C7.9 6.3 7.9 5.7 8.3 5.3C8.7 4.9 9.3 4.9 9.7 5.3L15.7 11.3C16.1 11.7 16.1 12.3 15.7 12.7Z" fill="white"/>
                  </mask>
                  <g mask="url(#mask0_764_2539)">
                    <rect width="24" height="24" fill="#6E6B7B"/>
                  </g>
                </svg>
              </div>
            </div>
        </div>
      </ng-container>

      <!-- No results found -->
      <ng-template #noResultsPages>
        <ul class="pl-0">
        <li *ngIf="searchText.length > 1" class="auto-suggestion justify-content-between">
          <a class="d-flex align-items-center justify-content-between w-100 py-50">
            <div class="d-flex justify-content-start">
              <i data-feather="alert-circle" class="mr-25"></i>
              <span>{{'HEADER.NOT_FOUND' | translate}}</span>
            </div></a
          >
        </li>
        </ul>
      </ng-template>
      <!--/ Pages -->
    </div>
    <!--/ Search List -->
  </div>
</div>
